import '../style/form/form.css'

const FormItem = ({ children, gridColumn, gridRow, style:passedStyle={}, className, order }) => {

    const style = {...passedStyle}
    if(gridColumn) style.gridColumn = gridColumn;
    if(gridRow) style.gridRow = gridRow;
    if(order) style.order = order;

    return (
        <div style={style} className={"input-form-item" + (className ? " " + className : "")}>
            {children}
        </div>
    )
}

export default FormItem;
